import clsx from 'clsx';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Banner, FormInput, Loader, Tooltip } from 'components';
import { routes } from 'router';
import { appService } from 'services';

const ForgotPasswordForm = () => {
  const { t } = useTranslation();
  const {
    formState: { isValid },
    isLoading,
    onSubmit,
    request
  } = useFormContext();
  return (
    <>
      {!request.success && (
        <>
          <h1 className="h1 underlined-yellow mb-6">{t('auth:passwordRecover.title')}</h1>
          <p className="text-sm lg:text-base text-gray-600 mb-2">{t('auth:passwordRecover.description')}</p>
          <form onSubmit={onSubmit}>
            <div className="relative">
              <FormInput
                name="userId"
                label={t('form:userId')}
                rules={{
                  required: true,
                  maxLength: {
                    value: 125,
                    message: t('form:maxLength', { field: t('form:userId'), length: 125 })
                  }
                }}
                placeholder={t('form:userId')}
                icon={{ name: 'id-badge', style: 'fad' }}
                dataTestId="userId"
              />

              <Tooltip
                className="absolute right-2 top-11"
                content={t('auth:login.userIdTooltip')}
                id="forgot-password-help"
              />
            </div>

            <button
              type="submit"
              disabled={!isValid || isLoading}
              className={clsx('mt-6 btn mx-auto', { disabled: !isValid })}
              data-test-id="forgotPasswordSubmit"
            >
              {isLoading && <Loader loaderClass="w-4 h-4 text-white mr-2" />}
              {t('auth:forgotPassword.button')}
            </button>
          </form>
          <div className="text-center mb-14 block-divider" />
          <h2 className="h2 underlined-yellow mb-6">{t('auth:identifierLost.title')}</h2>
          <p className="text-sm lg:text-base text-gray-600 mb-2">
            {t('auth:identifierLost.description.part1')}
            <a href={appService.getAssistanceUrl()} className="underline text-primary-500 ml-1 hover:no-underline">
              {t('auth:identifierLost.description.linkText')}
            </a>
          </p>

          {appService.isTouloisirs() && (
            <p className="text-sm lg:text-base text-gray-600 mb-4">{t('auth:identifierLost.description.part2')}</p>
          )}
          <a href={appService.getAssistanceUrl()} className="mt-6 btn outlined mx-auto">
            {t('buttons.contactUs')}
          </a>
        </>
      )}

      {request.success && (
        <>
          <Banner icon={{ name: 'envelope-circle-check', style: 'fad' }} dataTestId="forgotPasswordSuccessContent">
            {t('auth:forgotPassword.successContent')}
          </Banner>
          <Link to={routes.login.path} className="btn mt-6 mx-auto">
            {t('auth:login.button')}
          </Link>
        </>
      )}
    </>
  );
};

export default ForgotPasswordForm;
